<template>
  <b-form-group
    label="Status da Adesão"
    label-for="statusDaAdesao"
    label-class="font_size_label statusDaAdesao"
  >
    <validation-provider #default="{ errors }" name="Status da Adesão">
      <v-select
        id="statusDaAdesao"
        :options="options"
        v-model="selected"
        placeholder="Todos os status"
        label="descricao"
        :clearable="true"
        multiselect
        multiple
      >
        <template #list-header v-if="options.length > 0">
          <div class="vs__dropdown-option" @click="toggleSelectAll">
            <input type="checkbox" class="mr-1" :checked="isAllSelected" @click.stop="toggleSelectAll"/>
            <span>Selecionar Todos</span>
          </div>
        </template>
        <span slot="no-options">Nenhuma opção selecionável.</span>
      </v-select>
      <small v-if="errors[0]" class="text-danger">
        {{ errors[0] }}
      </small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import {
  BForm,
  BCol,
  BRow,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BSpinner,
  BFormDatepicker,
  BFormTextarea,
  BOverlay,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";

export default {
  components: {
    BForm,
    BCol,
    BRow,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BSpinner,
    BFormDatepicker,
    BFormTextarea,
    BOverlay,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  props: {
    value: {
      required: true,
    },
  },
  data() {
    return {
      options: [],
      selected: this.value,
    };
  },
  beforeMount() {
    this.options = [
      {
        descricao: "Cancelado",
        situacao_adesao: "Cancelado",
      },
      {
        descricao: "Lançado",
        situacao_adesao: "Concluído",
      },
    ];
  },
  methods: {
    toggleSelectAll() {
      if (this.isAllSelected) {
        this.selected = [];
      } else {
        this.selected = [...this.options];
      }
    }
  },
  computed: {
    isAllSelected() {
      return this.selected && this.selected.length === this.options.length;
    },
  },
  watch: {
    selected: function (valor) {
      this.$emit("selected", valor);
    },
  },
};
</script>

